export default __webpack_public_path__ + "static/media/sun.7d1e1b01.svg";